/*=========================================================================================
  File Name: moduleDevice.js
  Description: Device Module
==========================================================================================*/

import state from "./moduleDeviceState.js";
import mutations from "./moduleDeviceMutations.js";
import actions from "./moduleDeviceActions.js";
import getters from "./moduleDeviceGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
